export const DEBATE_FEED_RULES = {
  '1v1': {
    turnLogic: 'Alternating turns. Each debater gets equal number of turns.',
    maxTurns: 4,
    turnDuration: 120,
    scoring: {
      judgeBased: true,
      criteria: ['Clarity', 'Logic', 'Rebuttal Strength'],
      audienceVoting: false,
    },
    moderatorControls: false,
    spectatorInput: false,
    roundStructure: ['Opening', 'Rebuttal', 'Closing'],
  },

  parliamentary: {
    turnLogic: 'Sequential speeches from Government and Opposition benches.',
    maxTurns: 8,
    turnDuration: 420,
    scoring: {
      judgeBased: true,
      criteria: ['Team cohesion', 'Matter, Manner, Method'],
      audienceVoting: false,
    },
    moderatorControls: true,
    spectatorInput: true,
    roundStructure: [
      'Opening Gov',
      'Opening Opp',
      'Closing Gov',
      'Closing Opp',
    ],
  },

  LD: {
    turnLogic:
      'Affirmative presents case, Negative cross-examines and refutes. Alternating rebuttals.',
    maxTurns: 5,
    turnDuration: 180,
    scoring: {
      judgeBased: true,
      criteria: ['Value Framework', 'Philosophical Consistency', 'Refutation'],
      audienceVoting: false,
    },
    moderatorControls: true,
    spectatorInput: false,
    roundStructure: ['AC-Affirmative Constructive', 'NC-Negative Constructive', 'CX-Cross-Examination', 'Rebuttals'],
  },

  policy: {
    turnLogic:
      'Structured plan/counterplan, followed by cross-examination and rebuttal.',
    maxTurns: 6,
    turnDuration: 240,
    scoring: {
      judgeBased: true,
      criteria: ['Evidence Quality', 'Plan Strength', 'Refutation'],
      audienceVoting: false,
    },
    moderatorControls: true,
    spectatorInput: false,
    roundStructure: ['Constructive', 'CX', 'Rebuttals', 'Summary'],
  },

  publicForum: {
    turnLogic:
      'Teams alternate speeches, followed by "Crossfire" questioning.',
    maxTurns: 8,
    turnDuration: 180,
    scoring: {
      judgeBased: true,
      criteria: ['Clarity', 'Persuasiveness', 'Responsiveness'],
      audienceVoting: false,
    },
    moderatorControls: true,
    spectatorInput: false,
    roundStructure: ['Intro', 'Crossfire', 'Summary', 'Final Focus'],
  },

  oxford: {
    turnLogic: 'Proposition and Opposition alternate. Audience votes before and after.',
    maxTurns: 4,
    turnDuration: 300,
    scoring: {
      judgeBased: false,
      criteria: ['Audience Vote Shift'],
      audienceVoting: true,
    },
    moderatorControls: true,
    spectatorInput: true,
    roundStructure: ['Opening', 'Rebuttal', 'Q&A', 'Closing'],
  },

  forum: {
    turnLogic: 'Asynchronous or simultaneous contributions in threaded discussion.',
    maxTurns: null,
    turnDuration: null,
    scoring: {
      judgeBased: false,
      criteria: [],
      audienceVoting: true,
    },
    moderatorControls: true,
    spectatorInput: true,
    roundStructure: ['Open Discussion'],
  },

  cx: {
    turnLogic: 'Constructive speeches, structured cross-examinations, and rebuttals.',
    maxTurns: 6,
    turnDuration: 180,
    scoring: {
      judgeBased: true,
      criteria: ['CX Sharpness', 'Rebuttal Precision'],
      audienceVoting: false,
    },
    moderatorControls: true,
    spectatorInput: false,
    roundStructure: ['AC', 'NC', 'CX', 'Rebuttals'],
  },

  mace: {
    turnLogic: 'Speakers from each side present uninterrupted; no POIs allowed.',
    maxTurns: 4,
    turnDuration: 240,
    scoring: {
      judgeBased: true,
      criteria: ['Speech Structure', 'Rhetorical Skill'],
      audienceVoting: false,
    },
    moderatorControls: true,
    spectatorInput: false,
    roundStructure: ['Opening', 'Rebuttal', 'Summary'],
  },

  townHall: {
    turnLogic: 'Flexible format with open Q&A from audience.',
    maxTurns: null,
    turnDuration: null,
    scoring: {
      judgeBased: false,
      criteria: [],
      audienceVoting: true,
    },
    moderatorControls: true,
    spectatorInput: true,
    roundStructure: ['Panel', 'Audience Questions'],
  },

  fishbowl: {
    turnLogic: 'Participants rotate in and out of inner circle for structured discussion.',
    maxTurns: null,
    turnDuration: null,
    scoring: {
      judgeBased: false,
      criteria: [],
      audienceVoting: true,
    },
    moderatorControls: true,
    spectatorInput: true,
    roundStructure: ['Inner Discussion', 'Rotation', 'Reflection'],
  },

  spar: {
    turnLogic:
      'Short preparation, followed by rapid back-and-forth arguments.',
    maxTurns: 4,
    turnDuration: 90,
    scoring: {
      judgeBased: true,
      criteria: ['Spontaneity', 'Delivery'],
      audienceVoting: false,
    },
    moderatorControls: false,
    spectatorInput: false,
    roundStructure: ['Intro', 'Rebuttal', 'Final'],
  },

  devilsAdvocate: {
    turnLogic: 'Challenger is assigned opposite stance. Emphasis on cognitive dissonance.',
    maxTurns: 2,
    turnDuration: 180,
    scoring: {
      judgeBased: true,
      criteria: ['Counter Perspective Quality'],
      audienceVoting: true,
    },
    moderatorControls: true,
    spectatorInput: true,
    roundStructure: ['Statement', 'Defense'],
  },
};
